import { render, staticRenderFns } from "./BudgetManager.vue?vue&type=template&id=004fcc4e&lang=pug"
import script from "./BudgetManager.vue?vue&type=script&lang=ts"
export * from "./BudgetManager.vue?vue&type=script&lang=ts"
import style0 from "./BudgetManager.vue?vue&type=style&index=0&id=004fcc4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports